import {
  getDataAPI,
  postDataAPI,
  patchDataAPI,
  putDataAPI,
  patchWithoutDataAPI,
} from "../../../helper/api";

export const getUserDetailsById = (payload) => {
  return getDataAPI(`/api/Account/User/${payload}`);
};

// all users under a client
export const getUserDetailsByClientId = (payload) => {
  return getDataAPI(`/api/Account/Users/${payload}`);
};

export const getAllUserUnderClientAdmin = () => {
  return getDataAPI("/api/Account/Users");
};

export const getUserDetailsByLoginToken = () => {
  return getDataAPI("/api/Account/User");
};

export const createUser = (payload) => {
  return postDataAPI("/api/Account/User", { ...payload });
};

export const updateUser = (payload) => {
  return putDataAPI("/api/Account/User", { ...payload });
};

export const updateUserAccess = (payload) => {
  return patchDataAPI(`/api/Account/UserAccess/${payload.id}`, {
    isActive: payload.isActive,
  });
};

export const updateUserToAdminOrNotAdmin = (payload) => {
  return patchDataAPI(`/api/Account/UserAdminAccess/${payload.id}`, {
    isAdminAccess: payload.isAdminAccess,
  });
};

export const getRoles = () => {
  return getDataAPI("/api/Account/Roles/1");
};

export const updateUserTnCAcceptance = (payload) => {
  return patchWithoutDataAPI("/api/Account/UpdateTnCCondition")
}